import type { AssignedClassGame } from '@wx-weiqi/contracts';

export type AssignedGamesView = 'CURRENT' | 'WAITING' | 'HISTORY' | 'ALL';

export function filterAssignedClassGames(
  games: readonly AssignedClassGame[],
  view: AssignedGamesView,
): readonly AssignedClassGame[] {
  return games.filter(
    (game) =>
      view === 'ALL' ||
      (view === 'WAITING'
        ? game.status === 'WAITING'
        : view === 'CURRENT'
          ? game.status !== 'FINISHED' && game.status !== 'ABORTED'
          : game.status === 'FINISHED' || game.status === 'ABORTED'),
  );
}

export const assignedGameStatusLabels: Readonly<Record<AssignedClassGame['status'], string>> = {
  CREATED: '等待对手',
  WAITING: '等待准备',
  READY: '即将开始',
  PLAYING: '对弈中',
  COUNTING_REQUESTED: '等待数子确认',
  SCORING: '数子中',
  FINISHED: '已结束',
  ABORTED: '已中止',
};
